// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"bffd215b","487":"dbd3ccb1","678":"8dd550b9"}[chunkId] + ".chunk.js";
};